import RealEstate from "../../../components/RealEstate";
import axios from "axios";

const BotTemplateCard: React.FC<{ data: any }> = ({ data }) => {
    return <RealEstate data={data?.res} />;
};

export async function getServerSideProps(): Promise<any> {
    const apiKey = process.env.REACT_APP_API_KEY;
    const apiSecret = process.env.REACT_APP_API_SECRET;
    const result = await axios({
        method: "get",
        url: "https://server.gallabox.com/devapi/bot-templates",
        headers: {
            apiSecret,
            apiKey,
        },
        data: {
            status: "published",
            category: "Real Estate",
        },
    }).then((response) => {
        return JSON.parse(JSON.stringify(response?.data));
    });

    return {
        props: {
            data: {
                res: result,
            },
        },
    };
}
export default BotTemplateCard;
